<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Void Cash/Bank Receipt Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
            <b-col lg="8">
                <b-row>
                    <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Void Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" readonly></b-form-input>
                        </b-input-group>
                    </b-col>   
                    <b-col lg="5">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Void Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                </b-row>                      
                <b-input-group >
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input  v-model="model.uraian" readonly></b-form-input>
                </b-input-group>
                <b-row>
                    <b-col lg="8">
                    <b-input-group>
                        <b-input-group-prepend><label>Receipt From</label></b-input-group-prepend>
                        <b-form-input  v-model="model.terimadari" disabled></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col lg="4">      
                        <b-input-group>
                            <b-input-group-prepend class="d-md-inline d-lg-none"><label>Receive Method</label></b-input-group-prepend>
                            <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Receive Method</span></b-input-group-prepend>
                            <b-form-select v-model="model.jenis" :plain="true" :options="jenisPaym" disabled></b-form-select>                              
                        </b-input-group>
                    </b-col>
                </b-row>                      
                <b-row >
                    <b-col lg="4" v-if="((model.jenis==='Cheque') || (model.jenis==='Giro'))">
                        <b-input-group >
                            <b-input-group-prepend><label>Cheque/Giro No.</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor_cek" readonly></b-form-input>
                        </b-input-group>
                    </b-col>   
                    <b-col lg="4" v-if="((model.jenis==='Cheque') || (model.jenis==='Giro'))">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Cheque/Giro Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tgl_giro" type="date" disabled></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Due/Efective Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tgl_terima" type="date"  disabled></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                </b-row>             
                <b-row>
                    <b-col lg="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.namabank" ></b-form-input>
                            <b-input-group-append>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                            </b-input-group-append>
                        </b-input-group>

                    </b-col>   
                    <b-col lg="5" v-if="(bankOnly=='1')">                            
                            <b-input-group >
                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Bank Account No.</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Bank Account#</span></b-input-group-prepend>
                                <b-form-input disabled v-model="model.nomorrek"></b-form-input>
                            </b-input-group>
                    </b-col>
                </b-row>                      
                <b-row>
                    <b-col lg="5">
                        <b-input-group >
                            <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number :minus="true" class="form-control text-right" separator="," v-model="model.valas_in" :precision="2" disabled></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="3">
                        <b-input-group >
                            <b-input-group-prepend><label>Bank Charges</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-inline d-lg-none"><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number :minus="true" class="form-control text-right" separator="," v-model="model.bcharge" :precision="2" readonly></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <b-input-group >
                            <b-input-group-prepend><label>Exch. Rate {{model.matauang || ''}}</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{uanguser}}</span></b-input-group-prepend>
                            <my-number :minus="true" class="form-control text-right" separator="," v-model="model.kurstrx" :precision="6" readonly></my-number>
                        </b-input-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4">
                <v-dim :model="model" :key="updateDimHdr"></v-dim>
            </b-col>
            </b-row>              
            <b-card no-body>
            <b-tabs card v-model="tabIndex">
                <b-tab title="AR Receipt" active>
                        <b-row class="mt-2 mr-3">
                            <b-col class="pr-4" cols="8">
                                <b-form-group label-cols=3 label-for="arCollection" label="AR Collection Settlement No.">
                                    <b-row>
                                        <b-col cols="4">
                                            <b-input-group >
                                                <b-form-input readonly v-model="arReceipt.paymno"  :state="!$v.arReceipt.arpaymKey.$error"></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col cols="8">
                                                <b-form-input v-model="arReceipt.custinfo" placeholder="customer" readonly></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group  label-cols=3 label="Description">
                                    <b-form-input v-model="arReceipt.uraian" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col class="pr-4" cols="4">
                                <b-form-group label-cols=3  label="Total Payment" >
                                    <b-input-group >
                                        <b-input-group-prepend>
                                        <span class="input-group-text" style="width:70px;">{{arReceipt.matauang}}</span>
                                        </b-input-group-prepend>
                                        <my-number :minus="true" class="form-control text-right" v-model="arReceipt.totalbyr" :precision="2" disabled></my-number>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group label-cols=3  label="Total AR Settlement" >
                                    <b-input-group >
                                        <b-input-group-prepend>
                                        <span class="input-group-text" style="width:70px;">{{arReceipt.matauang}}</span>
                                        </b-input-group-prepend>
                                        <my-number :minus="true" class="form-control text-right" v-model="arReceipt.settl_amt" :precision="2" disabled></my-number>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>

                <b-table
                    class="mb-0"
                    ref="tblArReceipt"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="arReceipt.items"
                    :fields="arReceipt.fields"
                    :current-page="arReceipt.page"
                    :per-page="arReceipt.limit" :key="arReceipt.paymno"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaibyr)="data">
                        {{data.item.nilaibyr|numFormat}}
                        </template>
                        <template v-slot:cell(kurskeAR)="data">
                        {{data.item.kurskeAR|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaibank)="data">
                        {{data.item.nilaibank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihkurs)="data">
                        {{data.item.selisihkurs|numFormat('0,0.00')}}
                        </template>
                </b-table>
                <b-row >
                    <b-col cols="4">
                    <div class="ml-2">
                        Showing {{(arReceipt.page - 1) * arReceipt.limit + 1}}
                        to <span v-if="((arReceipt.page * arReceipt.limit)>arReceipt.total)">{{arReceipt.total}}</span> <span v-else>{{arReceipt.page * arReceipt.limit}}</span>
                        of {{arReceipt.total}} entries
                    </div>
                    </b-col>
                    <b-col cols="4" >
                        <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
                        <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="arReceipt.limit"  size="sm" style="width:80px;"/>
                        </b-form-group>
                    </b-col>        
                    <b-col cols="4">            
                    <b-pagination
                        align="right"
                        :total-rows="arReceipt.total"
                        :per-page="arReceipt.limit"
                        v-model="arReceipt.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Adv.Settle (Excess Cash)">
                <b-table
                    class="mb-0"
                    ref="tblAdvSetPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="advSetPayment.items"
                    :fields="advSetPayment.fields"
                    :current-page="advSetPayment.page"
                    :per-page="advSetPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaiByr)="data">
                        {{data.item.nilaiByr|numFormat}}
                        </template>
                        <template v-slot:cell(kursBankKeAdv)="data">
                        {{data.item.kursBankKeAdv|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaiBank)="data">
                        {{data.item.nilaiBank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihKurs)="data">
                        {{data.item.selisihKurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editAdvSetPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="advSetNumber" label="Advance Settlement No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="advSetPayment.obj.nomor" :state="!$v.advSetPayment.obj.advSttlKey.$error"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Employee" >
                                <b-form-input v-model="advSetPayment.obj.crewinfo"  readonly></b-form-input>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="advSetPayment.obj.keterangan" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Outstanding Exceeds Cash" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{advSetPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" v-model="advSetPayment.obj.outstand" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="pr-4" cols="6">
                        <b-form-group label-cols=3  label="Payment in Original Amount" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{advSetPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="advSetPayment.obj.nilaiByr" :precision="2" :state="!$v.advSetPayment.obj.nilaiByr.$error" ></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="advSetPayment.obj.nilaiBank" :precision="2" :state="!$v.advSetPayment.obj.nilaiBank.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Exchange Rate Bank to Orig.Amt" >
                            <b-input-group >
                                <b-input-group-prepend>
                                    <span class="input-group-text pl-2 pr-2">{{model.matauang}} to {{advSetPayment.obj.matauang}} </span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="advSetPayment.obj.kursBankKeAdv" :precision="6" :state="!$v.advSetPayment.obj.kursBankKeAdv.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3 label-for="advSetKodecash" label="Cash Flow">
                            <b-input-group >
                                <b-form-input readonly v-model="advSetPayment.obj.cashflow" :state="!$v.advSetPayment.obj.kodecash.$error"></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                            </div>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <div class="ml-2">
                        Showing
                        {{(advSetPayment.page - 1) * advSetPayment.limit + 1}}
                        to
                        {{advSetPayment.page * advSetPayment.limit}}
                        of
                        {{advSetPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="advSetPayment.total"
                        :per-page="advSetPayment.limit"
                        v-model="advSetPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Other">
                <b-table
                    class="mb-0"
                    ref="tblOthPayment"
                    outlined
                    striped hover small
                    :items="othPayment.items"
                    :fields="othPayment.fields"
                    :current-page="othPayment.page"
                    :per-page="othPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(ukeluar)="data">
                        {{data.item.ukeluar|numFormat}}
                        </template>
                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editOthPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="glAccount" label="GL Account No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="othPayment.obj.glAccount" :state="!$v.othPayment.obj.kodeacc.$error"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="othPayment.obj.uraian" :state="!$v.othPayment.obj.uraian.$error"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="othPayment.obj.ukeluar" :precision="2" :state="!$v.othPayment.obj.ukeluar.$error"></my-number>
                                    <b-input-group-append><span class="pt-2 ml-1" >CR &nbsp; ( <i class="fa fa-minus-square"></i> DB)</span></b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3 label-for="othPayKodecash" label="Cash Flow">
                                <b-input-group >
                                    <b-form-input readonly v-model="othPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('othPayment')" :state="!$v.othPayment.obj.kodecash.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="showLkuCashflow('othPayment')" id="othPayKodecash">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>

                        </b-col>
                        <b-col class="pr-4" cols="6">
                            <v-dim :model="othPayment.obj" :key="updateDimDtl"></v-dim>
                            
                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                            </div>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                        <div class="ml-2 mt-1" >
                          Showing {{(othPayment.page - 1) * othPayment.limit + 1}}
                          to <span v-if="((othPayment.page * othPayment.limit)>othPayment.total)">{{othPayment.total}}</span> <span v-else>{{othPayment.page * othPayment.limit}}</span>
                          of {{othPayment.total}} entries,   <span class="mr-1">limit per page :</span> 
                          <select  v-model="othPayment.limit"  style="width:60px;">
                            <option>5</option>                            
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                            <option>40</option>                            
                            <option>50</option>                            
                          </select>
                        </div>
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="othPayment.total"
                        :per-page="othPayment.limit"
                        v-model="othPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
            </b-tabs>
            </b-card>    
            <b-row h-align="between">                
                <b-col cols="4">
                    <b-form-group  label-cols=3  label="Total Detail Receipt" >
                            <b-input-group >
                                <b-input-group-prepend>
                                  <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" v-model="totalDtlPaym" :precision="2" disabled></my-number>
                            </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-append>
                                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                            </b-input-group-append>
                            <b-input-group-append>
                                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                            </b-input-group-append>
                        </b-input-group>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<style lang="scss">
.row-details-form {
    label {
    text-align: right !important;;
    }
    legend {
    text-align: right !important;;
    }

}
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import tranbank from "../../apis/tranbank";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim},
  mixins: [validationMixin],
  validations: {
        model: {
            trvoidkey: { required },
            isvoid: { required },
            tanggal: { required },
        },
        arReceipt: {
                arpaymKey: { required }
        },
        advSetPayment: {
            obj :{
                advSttlKey: { required },
                kodecash: { required },
                nilaiByr: { required, minValue:minValue(0.01) },
                nilaiBank: { required, minValue:minValue(0.01) },
                kursBankKeAdv: { required, minValue:minValue(0.0000001) }
            }
        },
        othPayment: {
            obj :{
                kodeacc: { required },
                uraian: { required },
                kodecash: { required },
                ukeluar: { required },
            }
        },
  }, 
  data() {
    return {
        currency:[{value:'IDR',text:'IDR'}],
        inputBerlanjut: 0,
        inputLineBerlanjut: 0,
        saveEnabled:true,
        jenisPaym : ['Cheque', 'Giro', 'Transfer', 'Debet R/K', 'Kredit R/K', 'Tunai'],
        model: {jenis:'Giro',kodecash:'-',
            kodebank: '',
            uraian: '',
            tanggal: '',nomor:'',
            jenis: '',
            matauang: this.$store.state.user.matauang,
            terimadari: '',
            valas_in: 0,
            kurstrx: 1
        },
        lblExchRate:"Exch. Rate to ",
        bankOnly:1,
        lkuBankaccountShow:false,
        lkuCashflowShow: false,
        lkuCashflowCaller:'arReceipt',        
        tabIndex:0,
        tahun:new Date().getFullYear(),
        totalDtlPaym:0,
        updateDimHdr:false,
        updateDimDtl:true,
        arReceipt: {
            arpaymKey:'',
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "invoiceno",
                    thStyle: "width:150px",
                    label: "Invoice Number"
                },
                {
                    key: "custinfo",
                    label: "Customer",
                    sortable: true
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaibyr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kurskeAR",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaibank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihkurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
            arpaymKey: ''
        },
        lkuApShow: false,
        advSetPayment: {
            items: [],
            selected:{},
            obj :{
                advSttlKey: '',
                kodecash: '',
                nilaiByr: 0,
                nilaiBank: 0,
                kursBankKeAdv: 1
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "AP Number"
                },
                {
                    key: "keterangan",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaiByr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kursBankKeAdv",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaiBank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihKurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuAdvSetShow: false,
        othPayment: {
            items: [],
            selected:{},
            obj :{
                kodeacc: '',
                uraian: '',
                kodecash: '',
                ukeluar: 0 , DimDtl:{}
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "glAccount",
                    label: "GL Account"
                },
                {
                    key: "ukeluar",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArReceipt() {
      this.$v.arReceipt.$touch();
      return this.$v.arReceipt.$invalid;
    },
    invalidAdvSetPayment() {
      this.$v.advSetPayment.obj.$touch();
      return this.$v.advSetPayment.obj.$invalid;
    },
    invalidOthPayment() {
      this.$v.othPayment.obj.$touch();
      return this.$v.othPayment.obj.$invalid;
    },
    caraBayar(){
        return this.model.jenis;
    },
    bankkas(){
        return this.model.kodebank;
    },
  },
  watch: {
    caraBayar: function(jenis) {
        if (jenis==='Tunai') {
            this.bankOnly='0';
        } else {
            this.bankOnly='1';
        }
        if (this.model.isbank!=this.bankOnly) {
            this.model.kodebank='';
            this.model.namabank='';
        }
    },    
    bankkas: function(kode) {
            if (this.uanguser.trim() == this.model.matauang.trim()) {
                this.model.kurstrx = 1;
            }
    },    
  },
  created: async function(){
      this.lblExchRate=`Exch. Rate to ${this.uanguser}`;
      this.saveEnabled=false;
      if (this.$route.params.id) {
          toastr.info('Loading Payment Detail, please wait')
          try {
            const [a,b,data] = await Promise.all([tranbank.currency(),tranbank.bankaccount(),await tranbank.receiptdetail(this.$route.params)]) ;
            this.currency = a;
            this.bankCashAcc = b;
            // const data = await tranbank.receiptdetail(this.$route.params);  

            const row = data[0][0];
            if (row.trvoidkey) {
                this.saveEnabled=(row.poststatus === 0);
                row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
                row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
                row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : '';
            } else {
                this.saveEnabled=true;
                row.nomor=`${row.nomor}/VOID`;           
                row.isvoid=1; 
                row.poststatus=0;
                row.valas_in = -1*row.valas_in;
                row.valas_out = -1*row.valas_out;
                row.bank_in = -1*row.bank_in;
                row.bank_out = -1*row.bank_out;
                row.bcharge = -1*row.bcharge;
                row.tanggal = row.tanggal ? moment().format('YYYY-MM-DD') : '';
                row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
                row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : '';
            } 
            
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.trvoidkey=row.trbankkey;
            this.model.trbankkey='';           
            if (data[1][0]) {
                this.arReceipt.arpaymKey = data[1][0].arpaymKey;
                this.arReceipt.paymno = data[1][0].paymno;
                this.arReceipt.custinfo = data[1][0].custinfo;
                this.arReceipt.uraian = data[1][0].uraian;
                this.arReceipt.totalbyr = -1*data[1][0].totalbyr;
                this.arReceipt.matauang = data[1][0].matauang || this.uanguser;
                this.arReceipt.settl_amt = -1*data[1][0].settl_amt;
                // this.arReceipt.cashflow = data[1][0].cashflow;
                // console.log('this.arReceipt : ',this.arReceipt);
            }
            this.arReceipt.items = data[2];
            this.arReceipt.total=this.arReceipt.items.length;
            
            this.advSetPayment.items = data[3];
            this.advSetPayment.total=this.advSetPayment.items.length;

            this.othPayment.items = data[4];
            this.othPayment.total=this.othPayment.items.length;

            if (this.arReceipt.items.length>0) {this.tabIndex=0;
            } else if (this.advSetPayment.items.length>0) {this.tabIndex=1;
            } else if (this.othPayment.items.length>0) {this.tabIndex=2;}
            if (!(row.trvoidkey)) {
                this.advSetPayment.items.forEach( function (trx) {
                    trx.advStlDtlKey='';
                    trx.nilaiByr=-1*trx.nilaiByr;
                    trx.nilaiBank=-1*nilaiByr;
                });
                this.othPayment.items.forEach( function (trx) {
                    trx.tablekey=''
                    trx.umasuk=-1*trx.umasuk;
                    trx.ukeluar=-1*trx.ukeluar;
                });
            }
            this.calcTotalDtlPaym();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            // if (this.model.jenis==='Tunai'){
            //     this.bankAccount = this.bankCashAcc.filter(r => r.isbank==0);
            // } 
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
  },
  methods: {
    save: async function () {
        console.log('Save Clicked');
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;            
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        // } else if (this.totalDtlPaym != parseFloat(this.model.valas_in)) {
        } else if (Math.abs(this.totalDtlPaym - (parseFloat(this.model.valas_in)+parseFloat(this.model.bcharge))) > 0.01) {
            toastr.error('[Transaction Amount] not Balance with [Total Detail Payment]', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            this.model.TableName = 'tranbank';
            try {
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    this.model.nomor = this.model.nomor || '';
                    this.model.isvoid = this.model.isvoid || 0;
                    this.model.poststatus = this.model.poststatus || 0;
                    this.model.valas_in = this.model.valas_in || 0;
                    this.model.valas_in = this.model.valas_in || 0;
                    this.model.bcharge = this.model.bcharge || 0;

                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.mode='receipt';
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : undefined;
                    row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : moment(row.tanggal).format('YYYY-MM-DD');

                    let newAdvSetPayments = this.advSetPayment.items.reduce((newArr, item) => {
                        if ((item.advSttlKey || '') != '') {
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    let newOthPayments = this.othPayment.items.reduce((newArr, item) => {
                        if ((item.kodeacc || '') != '') {
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);

                    if ((this.arReceipt.arpaymKey || '') != '')
                    {
                        row.arReceipt={ arpaymKey: this.arReceipt.arpaymKey };
                    }

                    row.advSetPayment = newAdvSetPayments;
                    row.othPayment = newOthPayments;
                    const hasil= await tranbank.insert(row);
                    toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Receipt",10000);
                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.saveEnabled=true;            
                        const _selected= {
                            kode: this.model.kodebank,
                            matauang: this.model.matauang,
                            namabank: this.model.namabank,
                            nomorrek: this.model.nomorrek,
                            isbank:this.model.isbank,
                            jenis: this.model.jenis
                        }
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        this.model.kurstrx=1;
                        this.model.valas_in= 0;
                        this.model.tanggal = moment().format('YYYY-MM-DD');
                        this.model.tgl_terima = moment().format('YYYY-MM-DD');
                        this.model.kodebank=_selected.kode;
                        this.model.matauang=_selected.matauang;
                        this.model.namabank=_selected.namabank;
                        this.model.nomorrek=_selected.nomorrek;
                        this.model.isbank=_selected.isbank;
                        this.model.jenis=_selected.jenis;
                        
                        this.bankOnly=1;
                        this.tabIndex=0;
                        this.tahun=new Date().getFullYear();
                        this.totalDtlPaym=0;
                        for (var key in this.arReceipt) {
                            this.arReceipt[key] = '';
                        }
                        this.arReceipt.items= [];
                        // this.arReceipt.selected= {};

                        this.advSetPayment.items= [];
                        this.advSetPayment.selected= {};
            
                        this.othPayment.items= [];
                        this.othPayment.selected= {};
                        this.$v.model.$reset();                        
                    }
                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.saveEnabled=true;            
                }

            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                   
                this.saveEnabled=true;            
            }

        }
    },
    closeAdvSetPayment: function(){
        const opened= this.advSetPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editAdvSetPayment : function (obj,callback) {
        this.closeAdvSetPayment();
        this.advSetPayment.selected = obj;
        for (var key in this.advSetPayment.obj) {
            this.advSetPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.advSetPayment.obj[key] = obj[key];
        }
        callback();
    },
    closeOthPayment: function(){
        const opened= this.othPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editOthPayment : function (obj,callback) {
        this.closeOthPayment();
        this.othPayment.selected = obj;
        for (var key in this.othPayment.obj) {
            this.othPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.othPayment.obj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.othPayment.obj[dim.value] = obj[dim.value];
                this.othPayment.obj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.othPayment.obj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        callback();
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        // let totalDtlPaym = this.model.bcharge || 0;
        let totalDtlPaym = 0;
        totalDtlPaym = totalDtlPaym + (this.arReceipt.totalbyr || 0);
        // this.arReceipt.items.forEach(function (trx) {
        //     if (trx.arpaymKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        // });
        this.advSetPayment.items.forEach( function (trx) {
            if (trx.advSttlKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaiBank);
        });
        this.othPayment.items.forEach( function (trx) {
            if (trx.kodeacc) totalDtlPaym = totalDtlPaym + parseFloat(trx.ukeluar);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    close(){
    //   router.push({name:'treasury.trxlist'});
      if (this.$store.state.prevRoute.name) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'treasury.trxlist'});
      }
    }
  }
};
</script>
